<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { title } = defineProps<{ title: string }>();
</script>

<template>
  <div class="product-zoning-group" data-testid="product-zoning-group">
    <div class="product-zoning-group__title">
      <Text font="body-medium-14">{{ title }}</Text>
    </div>
    <slot />
  </div>
</template>

<style scoped>
  .product-zoning-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .product-zoning-group__title {
    padding: 16px 0 8px;
  }
</style>
